import PropTypes from 'prop-types';
import React from 'react';

import { AdminPage } from '../lib/admin_layout';
import connect from 'components/lib/connect';
import LoadingSpinner from 'components/lib/loading_spinner';
import WebhookEditor from './webhook_editor';

export function WebhookEditorPage({ isEnabled, isLoading, webhookId }) {
  if (!isEnabled) {
    return null;
  }

  let bodyContent;
  if (isLoading) {
    bodyContent = <LoadingSpinner />;
  } else {
    bodyContent = <WebhookEditor webhookId={webhookId} />;
  }

  return <AdminPage>{bodyContent}</AdminPage>;
}

WebhookEditorPage.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  webhookId: PropTypes.string,
};

export default connect(mapStateToProps)(WebhookEditorPage);

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  return {
    isEnabled: isFeatureEnabled('devManagement'),
    isLoading: getProvider('webhooks').isLoading(),
    webhookId: getProvider('currentLocation').get().webhookId,
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/integrations/webhook_editor_page.jsx